<template>
  <PullToRefresh>
    <div :class="route.name === 'Asistente' ? '' : 'pb-32 lg:pb-0'">
      <router-view></router-view>
    </div>
  </PullToRefresh>
  
  <!-- Bottom Navigation Bar for PWA -->
  <BottomNavBar ref="bottomNavBar" />
  
  <!-- AI Assistant Global - Solo mostrar si está autenticado Y tiene AI habilitado Y plan incluye AI -->
  <AIChatAssistant v-if="isAuthenticated && aiEnabled && hasAiFeature" />
  
  <CookieBanner />

  <!-- Aviso de nueva versión disponible (PWA) -->
  <UpdateBanner />
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import Notiflix from "notiflix";
import { onMounted } from "vue";
import AIChatAssistant from "@/components/AIChatAssistant.vue";
import PullToRefresh from "@/components/PullToRefresh.vue";
import CookieBanner from "@/components/CookieBanner.vue";
import BottomNavBar from "@/components/BottomNavBar.vue";
import UpdateBanner from "@/components/UpdateBanner.vue";
import { useAuthStore } from "@/stores/auth";
import { usePlanFeatures } from "@/composables/usePlanFeatures";
import api from "@/helpers/apiClient";

const route = useRoute();
const authStore = useAuthStore();
const { init: initPlanFeatures, hasFeature, reset: resetPlanFeatures } = usePlanFeatures();
const isAuthenticated = computed(() => authStore.isAuthenticated);
const aiEnabled = ref(false);
const hasAiFeature = computed(() => hasFeature('ai'));

// Fetch AI status when user authenticates
async function checkAiStatus() {
  if (!isAuthenticated.value) {
    aiEnabled.value = false;
    return;
  }
  try {
    const response = await api.get('/api/ai/status');
    aiEnabled.value = response.data.ai_enabled === true;
  } catch {
    aiEnabled.value = false;
  }
}

watch(isAuthenticated, (newVal) => {
  if (newVal) {
    initPlanFeatures();
    checkAiStatus();
  } else {
    aiEnabled.value = false;
    resetPlanFeatures();
  }
});

onMounted(async () => {
  Notiflix.Loading.init({
    svgSize: "100px",
    svgColor: "#6366f1",
    clickToClose: false,
  });
  Notiflix.Loading.standard();

  try {
    if (isAuthenticated.value) {
      initPlanFeatures();
      checkAiStatus();
    }
  } catch (error) {
    console.error("Error durante inicialización:", error.message);
  } finally {
    Notiflix.Loading.remove();
  }
});
</script>
